import {
  MAIN_CATEGORIES_SUCCESS,
  MAIN_CATEGORIES_FAIL,
  CHILD_CATEGORIES_SUCCESS,
  CHILD_CATEGORIES_FAIL,
  SUB_CATEGORIES_SUCCESS,
  SUB_CATEGORIES_FAIL,
  CHILD_SUBCATEGORIES_FAIL,
  CHILD_SUBCATEGORIES_SUCCESS,
} from "../actions/types";

const initialState = {
  mainCategories: null,
  loading: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case MAIN_CATEGORIES_SUCCESS:
      return {
        ...state,
        mainCategories: payload,
        loading: false,
      };

    case MAIN_CATEGORIES_FAIL:
      return {
        ...state,
        mainCategories: null,
        loading: false,
      };

    case CHILD_CATEGORIES_SUCCESS:
      return {
        ...state,
        childCategories: payload,
        loading: false,
      };

    case CHILD_CATEGORIES_FAIL:
      return {
        ...state,
        childCategories: null,
        loading: false,
      };

    case SUB_CATEGORIES_SUCCESS:
      return {
        ...state,
        subCategories: payload,
        loading: false,
      };

    case SUB_CATEGORIES_FAIL:
      return {
        ...state,
        subCategories: null,
        loading: false,
      };
    case CHILD_SUBCATEGORIES_SUCCESS:
      return {
        ...state,
        childSubCategories: payload,
        loading: false,
      };

    case CHILD_SUBCATEGORIES_FAIL:
      return {
        ...state,
        childSubCategories: null,
        loading: false,
      };
    default:
      return state;
  }
}
